module.exports = __webpack_public_path__ + "static/media/DrSusan.90abffb5.png";